module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "imagey"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }), _c('img', {
    attrs: {
      "alt": "image",
      "src": "images/common1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("No living member of our family has ever seen it, but sources claim that a framed “hair picture,” woven from locks of our ancestors’ hair, figured strongly in one of the darkest chapters of our family history. If their claim is true, the weaving must have been an exquisite model of the form, for practitioners of hair art report that straight, black hair creates the most striking designs. Hair like Great-aunt Bessie’s and her siblings’. Hair from their grandparents and from their father, uncles, and aunts, the eleven children of Mother and Father Mounts. Braided strands of rich, black hair from thirteen members of the tribe, each bearing its individual streak—chestnut, sable, lampblack, coal—yet coiled into one continuous loop. Double helix, coded chain. Hair of my ancestors, the tribal knot.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7549a142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm4.vue
// module id = 90
// module chunks = 0